var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"friend"},[_c('div',{staticClass:"friend-list"},[_c('Tab')],1),_vm._v(" "),_c('div',{staticClass:"msg"},[_c('div',{staticStyle:{"position":"absolute","right":"10px","top":"10px","cursor":"pointer"},on:{"click":_vm.closeFn}},[_c('a-icon',{attrs:{"type":"close"}})],1),_vm._v(" "),_c('div',[_c('Meg')],1)])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76fdbff9","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/TASMini/views/Im/Im.vue
// module id = null
// module chunks = 